import React from 'react';
import './product-item-number.scss';
export class ItemNumber extends React.Component {
  render() {
    if (!this.props.contentData.partNumber) {
      return null;
    }
    return (
      <div>
        <span className='item-number'>Item #{this.props.contentData.partNumber}</span>
      </div>
    );
  }
}

export default ItemNumber;
